import { useQuery } from 'react-query';

import { CommonDependency } from '@/dependency';
import { formatNum } from '@/utils';
import { Channel } from '../RichTextEditor/types';

export const channelSearch = async (
  q: string,
): Promise<{
  channels: Channel[];
}> => {
  if (!q) {
    return Promise.resolve({
      channels: [],
    });
  }
  return CommonDependency.api.searchChannelList({ q });
};

export const transformChannel = ({ channels }: { channels: Channel[] }) => {
  return channels?.map(x => {
    x._followerCount = formatNum(x.follower_count);

    return x;
  });
};

export const useChannelSearch = (q?: string) => {
  return useQuery(['channle_search', q], () => channelSearch(q!), {
    enabled: !!q,
    select: transformChannel,
  });
};

export const useSuggestedChannelList = () => {
  return useQuery(['suggested_channel'], () => CommonDependency.api.getSuggestedChannelList(), {
    select: transformChannel,
  });
};

export const useFollowingChannelList = () => {
  return useQuery(['following_channel'], () => CommonDependency.api.getFollowingChannelList(), {
    select: transformChannel,
  });
};
